/* Shared by product popups and the local garment review. */
if (!customElements.get('rm-measurement-guide')) {
  customElements.define('rm-measurement-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rmGuideBound === 'true') return;
      this.dataset.rmGuideBound = 'true';
      this.addEventListener('click', (event) => {
        const view = event.target.closest('[data-rm-guide-view-button], [data-rm-guide-goto]');
        if (view && this.contains(view)) {
          this.selectView(view.dataset.rmGuideViewButton || view.dataset.rmGuideGoto);
          if (view.dataset.rmGuideGoto) this.querySelector(`[data-rm-guide-view-button="${view.dataset.rmGuideGoto}"]`)?.focus();
        }
        const measure = event.target.closest('[data-rm-body-measure]');
        if (measure && this.contains(measure)) this.selectMeasurement(measure.dataset.rmBodyMeasure);
        const person = event.target.closest('[data-rm-body-person-button]');
        if (person && this.contains(person)) this.selectPerson(person.dataset.rmBodyPersonButton);
        const zoom = event.target.closest('[data-rm-body-zoom]');
        if (zoom && this.contains(zoom)) this.toggleZoom(zoom.closest('[data-rm-body-photo]').querySelector('[data-rm-body-frame]:not([hidden])'));
        else if (event.target.matches('[data-rm-body-scroll] img') && this.contains(event.target)) {
          this.toggleZoom(event.target.closest('[data-rm-body-frame]'), event);
        }
      });
      // Tab list keyboard support: arrow keys, Home and End move between tabs.
      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[role="tab"][data-rm-guide-view-button]');
        if (!tab || !this.contains(tab)) return;
        const tabs = Array.from(this.querySelectorAll('[role="tab"][data-rm-guide-view-button]'));
        const index = tabs.indexOf(tab);
        const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: tabs.length - 1 }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        const target = tabs[(next + tabs.length) % tabs.length];
        this.selectView(target.dataset.rmGuideViewButton);
        target.focus();
      });
      this.selectView(this.dataset.rmDefaultView || 'garment');
    }

    selectView(view) {
      if (view !== 'body' && view !== 'garment') return;
      this.dataset.rmGuideView = view;
      this.querySelectorAll('[data-rm-guide-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.rmGuidePanel !== view;
      });
      this.querySelectorAll('[data-rm-guide-view-button]').forEach((button) => {
        const selected = button.dataset.rmGuideViewButton === view;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
    }

    selectMeasurement(measurement) {
      const selected = Array.from(this.querySelectorAll('[data-rm-body-measure]')).find((button) => button.dataset.rmBodyMeasure === measurement);
      if (!selected) return;
      this.querySelector('[data-rm-body-selected]').dataset.rmBodySelected = measurement;
      this.querySelectorAll('[data-rm-body-measure]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.rmBodyMeasure === measurement));
      });
      this.querySelectorAll('[data-rm-body-photo]').forEach((photo) => {
        photo.hidden = photo.dataset.rmBodyPhoto !== measurement;
      });
      this.querySelectorAll('[data-rm-body-instruction]').forEach((instruction) => {
        instruction.hidden = instruction.dataset.rmBodyInstruction !== measurement;
      });
      this.querySelectorAll('[data-rm-body-frame].is-zoomed').forEach((frame) => this.toggleZoom(frame));
    }

    selectPerson(person) {
      const guide = this.querySelector('[data-rm-body-person]');
      if (!guide || (person !== 'men' && person !== 'women')) return;
      guide.dataset.rmBodyPerson = person;
      this.querySelectorAll('[data-rm-body-person-button]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.rmBodyPersonButton === person));
      });
      this.querySelectorAll('[data-rm-body-person-photo]').forEach((frame) => {
        if (frame.classList.contains('is-zoomed')) this.toggleZoom(frame);
        frame.hidden = frame.dataset.rmBodyPersonPhoto !== person;
      });
    }

    toggleZoom(frame, event) {
      if (!frame) return;
      const zoomed = !frame.classList.contains('is-zoomed');
      const scroller = frame.querySelector('[data-rm-body-scroll]');
      const image = frame.querySelector('img');
      const figure = frame.closest('[data-rm-body-photo]');
      const button = figure && figure.querySelector('[data-rm-body-zoom]');
      // Open the enlarged view on the spot that was tapped.
      let ratioX = 0.5;
      let ratioY = 0.5;
      if (zoomed && event && image) {
        const box = image.getBoundingClientRect();
        ratioX = Math.min(1, Math.max(0, (event.clientX - box.left) / box.width));
        ratioY = Math.min(1, Math.max(0, (event.clientY - box.top) / box.height));
      }
      frame.classList.toggle('is-zoomed', zoomed);
      if (image) image.sizes = zoomed ? '1536px' : image.dataset.rmBodySizes;
      if (button) {
        button.setAttribute('aria-pressed', String(zoomed));
        button.textContent = zoomed ? 'Reduce photo' : 'Enlarge photo';
      }
      if (scroller) {
        scroller.scrollLeft = zoomed ? ratioX * scroller.scrollWidth - scroller.clientWidth / 2 : 0;
        scroller.scrollTop = zoomed ? ratioY * scroller.scrollHeight - scroller.clientHeight / 2 : 0;
      }
    }
  });
}
